import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { createPortal } from "react-dom";
import { authService } from "../services/auth.service";

export default function Sidebar() {
  const location = useLocation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const currentAdmin = authService.getCurrentAdmin();

  const menuItems = [
    {
      path: "/dashboard",
      label: "Início",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
          <polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      )
    },
    {
      path: "/dashboard/admin",
      label: "Administradores",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      )
    },
    {
      path: "/dashboard/contacts",
      label: "Contatos",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
      )
    },
    {
      path: "/dashboard/users",
      label: "Usuários",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      )
    },
    {
      path: "/dashboard/posts",
      label: "Publicações",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
          <polyline points="13 2 13 9 20 9"/>
        </svg>
      )
    },
    {
      path: "/dashboard/species",
      label: "Espécies",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="4" r="2"/>
          <circle cx="18" cy="8" r="2"/>
          <circle cx="20" cy="16" r="2"/>
          <path d="M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z"/>
        </svg>
      )
    },
    {
      path: "/dashboard/marketing",
      label: "Marketing",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 4h18v6H3z"></path>
            <path d="M3 14h18v6H3z"></path>
            <path d="M7 4v16"></path>
        </svg>
      )
    }
  ];

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    authService.logout();
    setShowLogoutModal(false);
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  // Bloquear scroll quando modal estiver aberto
  useEffect(() => {
    if (showLogoutModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showLogoutModal]);

  const LogoutModal = () => {
    if (!showLogoutModal) return null;

    return createPortal(
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: "100vw",
          height: "100vh",
          background: "rgba(0, 0, 0, 0.75)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
          animation: "fadeIn 0.3s ease-out",
        }}
        onClick={cancelLogout}
      >
        <div
          style={{
            background: "var(--card)",
            padding: 40,
            borderRadius: 20,
            maxWidth: 480,
            width: "90%",
            boxShadow: "0 25px 50px rgba(0, 0, 0, 0.5), 0 10px 20px rgba(0, 0, 0, 0.3)",
            animation: "modalBounceIn 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
            border: "1px solid var(--border)",
            position: "relative",
            zIndex: 100000,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ textAlign: "center", marginBottom: 28 }}>
            <div
              style={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #fef3c7 0%, #fbbf24 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                boxShadow: "0 8px 16px rgba(251, 191, 36, 0.3)",
              }}
            >
              <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#92400e" strokeWidth="2.5">
                <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h3
              style={{
                fontSize: 24,
                fontWeight: 700,
                marginBottom: 12,
                color: "var(--card-foreground)",
                letterSpacing: "-0.5px",
              }}
            >
              Confirmar Logout
            </h3>
            <p
              style={{
                color: "var(--muted-foreground)",
                fontSize: 15,
                lineHeight: 1.6,
              }}
            >
              Tem certeza que deseja sair da sua conta?
            </p>
          </div>
          <div style={{ display: "flex", gap: 12, justifyContent: "stretch" }}>
            <button
              onClick={cancelLogout}
              style={{
                flex: 1,
                background: "var(--muted)",
                color: "var(--card-foreground)",
                border: "2px solid var(--border)",
                padding: "14px 24px",
                borderRadius: 12,
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 15,
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "var(--card)";
                e.currentTarget.style.transform = "translateY(-2px)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "var(--muted)";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Cancelar
            </button>
            <button
              onClick={confirmLogout}
              style={{
                flex: 1,
                background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                color: "white",
                border: "none",
                padding: "14px 24px",
                borderRadius: 12,
                cursor: "pointer",
                fontWeight: 600,
                fontSize: 15,
                boxShadow: "0 4px 14px rgba(239, 68, 68, 0.4)",
                transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px) scale(1.02)";
                e.currentTarget.style.boxShadow = "0 8px 24px rgba(239, 68, 68, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) scale(1)";
                e.currentTarget.style.boxShadow = "0 4px 14px rgba(239, 68, 68, 0.4)";
              }}
            >
              Sair
            </button>
          </div>
        </div>

        <style>
          {`
            @keyframes fadeIn {
              from {
                opacity: 0;
              }
              to {
                opacity: 1;
              }
            }

            @keyframes modalBounceIn {
              0% {
                opacity: 0;
                transform: scale(0.7) translateY(-30px);
              }
              50% {
                transform: scale(1.05);
              }
              100% {
                opacity: 1;
                transform: scale(1) translateY(0);
              }
            }
          `}
        </style>
      </div>,
      document.body
    );
  };

  return (
    <aside
      style={{
        width: isCollapsed ? 80 : 260,
        background: "var(--card)",
        borderRight: "1px solid var(--border)",
        padding: isCollapsed ? "24px 12px" : 24,
        display: "flex",
        flexDirection: "column",
        position: "sticky",
        top: 0,
        height: "100vh",
        boxSizing: "border-box",
        boxShadow: "2px 0 8px rgba(0, 0, 0, 0.05)",
        overflowX: "hidden",
        overflowY: "auto",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
      }}
    >
      <div style={{
        flex: 1,
        overflowY: "auto",
        overflowX: "hidden",
        minHeight: 0,
        marginBottom: 20,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 32 }}>
          <Link
            to="/dashboard"
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              gap: 12,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            }}
          >
            {isCollapsed ? (
              <img
                src="/logo-mark.png"
                alt="Achou Pet"
                style={{
                  width: 40,
                  height: 40,
                  objectFit: "contain",
                  display: "block",
                }}
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                <img
                  src="/logo-horizontal.png"
                  alt="Achou Pet"
                  style={{
                    width: 140,
                    height: "auto",
                    display: "block",
                  }}
                />
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: "var(--muted-foreground)",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                  }}
                >
                  Painel administrativo
                </span>
              </div>
            )}
          </Link>

          <button
            onClick={() => setIsCollapsed(!isCollapsed)}
            style={{
              background: "var(--muted)",
              border: "1px solid var(--border)",
              borderRadius: 8,
              padding: 8,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              color: "var(--muted-foreground)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "var(--primary)";
              e.currentTarget.style.color = "white";
              e.currentTarget.style.borderColor = "var(--primary)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "var(--muted)";
              e.currentTarget.style.color = "var(--muted-foreground)";
              e.currentTarget.style.borderColor = "var(--border)";
            }}
            title={isCollapsed ? "Expandir sidebar" : "Recolher sidebar"}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              style={{
                transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              }}
            >
              <polyline points="11 17 6 12 11 7"/>
              <polyline points="18 17 13 12 18 7"/>
            </svg>
          </button>
        </div>

        <nav style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                style={{
                  background: isActive
                    ? "linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%)"
                    : "transparent",
                  color: isActive
                    ? "white"
                    : "var(--muted-foreground)",
                  textDecoration: "none",
                  padding: isCollapsed ? "12px" : "12px 16px",
                  borderRadius: 10,
                  fontWeight: isActive ? 600 : 500,
                  fontSize: 15,
                  transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
                  border: isActive ? "none" : "1px solid transparent",
                  display: "flex",
                  alignItems: "center",
                  gap: 12,
                  justifyContent: isCollapsed ? "center" : "flex-start",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
                onMouseEnter={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = "var(--muted)";
                    e.currentTarget.style.color = "var(--card-foreground)";
                    e.currentTarget.style.transform = isCollapsed ? "scale(1.05)" : "translateX(4px)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (!isActive) {
                    e.currentTarget.style.background = "transparent";
                    e.currentTarget.style.color = "var(--muted-foreground)";
                    e.currentTarget.style.transform = "translateX(0) scale(1)";
                  }
                }}
                title={isCollapsed ? item.label : undefined}
              >
                <span style={{ display: 'flex', flexShrink: 0 }}>{item.icon}</span>
                {!isCollapsed && <span>{item.label}</span>}
              </Link>
            );
          })}
        </nav>
      </div>

      <div style={{ flexShrink: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {/* Informação do usuário logado */}
        {currentAdmin && currentAdmin.email && (
          <div
            style={{
              background: "linear-gradient(135deg, var(--muted) 0%, var(--card) 100%)",
              border: "1px solid var(--border)",
              borderRadius: 12,
              padding: isCollapsed ? "12px" : "16px",
              display: "flex",
              alignItems: "center",
              gap: 12,
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div
              style={{
                width: isCollapsed ? 32 : 40,
                height: isCollapsed ? 32 : 40,
                borderRadius: "50%",
                background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 700,
                fontSize: isCollapsed ? 14 : 16,
                flexShrink: 0,
                boxShadow: "0 2px 8px rgba(59, 130, 246, 0.3)",
              }}
              title={isCollapsed ? currentAdmin.email : undefined}
            >
              <svg width={isCollapsed ? 16 : 20} height={isCollapsed ? 16 : 20} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            {!isCollapsed && (
              <div style={{ flex: 1, minWidth: 0 }}>
                <div
                  style={{
                    fontSize: 12,
                    fontWeight: 500,
                    color: "var(--muted-foreground)",
                    marginBottom: 4,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                  }}
                >
                  Conectado como
                </div>
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "var(--card-foreground)",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {currentAdmin.email}
                </div>
              </div>
            )}
          </div>
        )}

        <button
          onClick={handleLogout}
          style={{
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            color: "white",
            border: "none",
            padding: isCollapsed ? "14px" : "14px 18px",
            borderRadius: 10,
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 15,
            boxShadow: "0 4px 12px rgba(239, 68, 68, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            whiteSpace: "nowrap",
            overflow: "hidden",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(239, 68, 68, 0.4)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(239, 68, 68, 0.3)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
          title={isCollapsed ? "Sair" : undefined}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ flexShrink: 0 }}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
          </svg>
          {!isCollapsed && <span>Sair</span>}
        </button>
      </div>

      <LogoutModal />
    </aside>
  );
}
